var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('CustomList',{ref:"CustomList",attrs:{"columns":_vm.tableColumns,"list-query":_vm.listQuery},on:{"getList":_vm.getList}}),_c('Form',{ref:"Form",on:{"submit":function($event){return _vm.handleSearch()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }